gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
document.addEventListener("DOMContentLoaded", () => {
	// GSAP Fade In Up Animation for logo carousel blocks
	// Check if GSAP is available and initialize fade-in-up animations
	if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
		const fadeInUpElements = document.querySelectorAll(".carousel-gsap-fade-in-up");
		if (fadeInUpElements.length) {
			gsap.utils.toArray(".carousel-gsap-fade-in-up").forEach((element) => {
				gsap.timeline({
					scrollTrigger: {
						trigger: element,
						start: "top 99%",
						end: "bottom 10%",
						toggleActions: "play none none none",
					},
				}).from(element, {
					duration: 1,
					opacity: 0,
					y: 30,
					ease: "power2.out",
				});
			});
		}
	}

	// Initialize all logo carousels on the page
	const carousels = document.querySelectorAll(".logo-carousel__wrapper");

	carousels.forEach((carousel) => {
		// Check if there are enough slides to initialize the carousel
		const cards = carousel.querySelectorAll(".logo-carousel__card");
		if (cards.length === 0) return;

		const cardsContainer = carousel.querySelector(".logo-carousel__cards");
		const flexContainer = carousel.querySelector(".logo-carousel__flex");
		
		// Clone cards to create seamless loop (triple the cards for smooth infinite scroll)
		const originalCards = [...cards];
		
		// Clone cards twice to ensure smooth looping
		originalCards.forEach(card => {
			cardsContainer.appendChild(card.cloneNode(true));
		});
		originalCards.forEach(card => {
			cardsContainer.appendChild(card.cloneNode(true));
		});
        originalCards.forEach(card => {
			cardsContainer.appendChild(card.cloneNode(true));
		});
		originalCards.forEach(card => {
			cardsContainer.appendChild(card.cloneNode(true));
		});

		// Calculate dimensions
		const cardWidth = 110; // Base card width
		const cardGap = 100; // Gap between cards
		const totalCardWidth = cardWidth + cardGap;
		const totalWidth = totalCardWidth * originalCards.length;

		// Add CSS animation class
		cardsContainer.classList.add("logo-carousel--animated");
		
		// Set CSS custom properties for animation
		cardsContainer.style.setProperty("--slide-width", `${totalWidth}px`);
		
		// Calculate animation duration based on number of cards (3s per card for smooth motion)
		const animationDuration = originalCards.length * 3;
		cardsContainer.style.setProperty("--animation-duration", `${animationDuration}s`);

		// Draggable functionality
		let isDragging = false;
		let startX = 0;
		let scrollLeft = 0;
		let animationPaused = false;
		let currentTransform = 0;

		// Function to get current transform value
		const getCurrentTransform = () => {
			const style = window.getComputedStyle(cardsContainer);
			const matrix = style.transform;
			if (matrix === 'none') return 0;
			const values = matrix.split('(')[1].split(')')[0].split(',');
			return parseFloat(values[4]) || 0;
		};

		// Mouse events for dragging
		flexContainer.addEventListener("mousedown", (e) => {
			isDragging = true;
			startX = e.pageX;
			currentTransform = getCurrentTransform();
			
			// Pause animation and store current position
			cardsContainer.style.animationPlayState = "paused";
			cardsContainer.style.transform = `translateX(${currentTransform}px)`;
			cardsContainer.style.animation = "none";
			
			// Change cursor
			//flexContainer.style.cursor = "grabbing";
			
			// Prevent text selection
			e.preventDefault();
		});

		document.addEventListener("mousemove", (e) => {
			if (!isDragging) return;
			
			e.preventDefault();
			const x = e.pageX;
			const walk = (x - startX) * 2; // Multiply by 2 for faster drag
			
			// Apply transform
			cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			
			// Check if we need to reset position for infinite loop
			const currentPos = currentTransform + walk;
			if (currentPos > 0) {
				currentTransform -= totalWidth;
				cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			} else if (currentPos < -totalWidth * 2) {
				currentTransform += totalWidth;
				cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			}
		});

		document.addEventListener("mouseup", () => {
			if (isDragging) {
				isDragging = false;
				//flexContainer.style.cursor = "grab";
				
				// Resume animation from current position
				const finalTransform = getCurrentTransform();
				const progress = Math.abs(finalTransform % totalWidth) / totalWidth;
				
				// Restart animation with adjusted duration
				cardsContainer.style.animation = "";
				cardsContainer.classList.add("logo-carousel--animated");
				cardsContainer.style.animationPlayState = animationPaused ? "paused" : "running";
				cardsContainer.style.animationDelay = `-${progress * animationDuration}s`;
			}
		});

		// Handle hover pause/play
		carousel.addEventListener("mouseenter", () => {
			animationPaused = true;
			if (!isDragging) {
				cardsContainer.style.animationPlayState = "paused";
			}
			//flexContainer.style.cursor = "grab";
		});

		carousel.addEventListener("mouseleave", () => {
			animationPaused = false;
			if (!isDragging) {
				cardsContainer.style.animationPlayState = "running";
			}
			//flexContainer.style.cursor = "default";
		});

		// Touch events for mobile dragging
		let touchStartX = 0;
		
		flexContainer.addEventListener("touchstart", (e) => {
			isDragging = true;
			touchStartX = e.touches[0].clientX;
			currentTransform = getCurrentTransform();
			
			// Pause animation
			cardsContainer.style.animationPlayState = "paused";
			cardsContainer.style.transform = `translateX(${currentTransform}px)`;
			cardsContainer.style.animation = "none";
		});

		flexContainer.addEventListener("touchmove", (e) => {
			if (!isDragging) return;
			
			const x = e.touches[0].clientX;
			const walk = (x - touchStartX) * 2;
			
			// Apply transform
			cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			
			// Check if we need to reset position for infinite loop
			const currentPos = currentTransform + walk;
			if (currentPos > 0) {
				currentTransform -= totalWidth;
				cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			} else if (currentPos < -totalWidth * 2) {
				currentTransform += totalWidth;
				cardsContainer.style.transform = `translateX(${currentTransform + walk}px)`;
			}
		});

		flexContainer.addEventListener("touchend", () => {
			if (isDragging) {
				isDragging = false;
				
				// Resume animation from current position
				const finalTransform = getCurrentTransform();
				const progress = Math.abs(finalTransform % totalWidth) / totalWidth;
				
				// Restart animation with adjusted duration
				cardsContainer.style.animation = "";
				cardsContainer.classList.add("logo-carousel--animated");
				cardsContainer.style.animationPlayState = animationPaused ? "paused" : "running";
				cardsContainer.style.animationDelay = `-${progress * animationDuration}s`;
			}
		});
	});
});